import { render, staticRenderFns } from "./TheLeaguePage.vue?vue&type=template&id=2ddd5f76&scoped=true"
import script from "./TheLeaguePage.vue?vue&type=script&lang=ts"
export * from "./TheLeaguePage.vue?vue&type=script&lang=ts"
import style0 from "./TheLeaguePage.vue?vue&type=style&index=0&id=2ddd5f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddd5f76",
  null
  
)

export default component.exports